import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const About = () => {
    return (
        <div className="container">
            <Navbar />

            <div className="about-us-banner">
                <div className="text">About Us</div>
            </div>

            <div className="about-stay-connected">
                <div className="content">
                    <div className="paragraph">Stay connected to Pfizer’s values of <span>Joy, Courage, Equity, and Excellence</span> through the Pfizer Alumni Community.</div>
                    <div className="paragraph">We cultivate <span>Joy</span> by bringing alumni back together on a dedicated platform that makes it easy to reconnect, share stories, and access resources and networking opportunities.</div>
                    <div className="paragraph">We champion <span>Excellence</span> by encouraging the exchange of knowledge, experience, and insights—learning from one another and strengthening our collective expertise.</div>
                    <div className="paragraph"><span>Courage</span> fuels growth beyond Pfizer, and we support that journey through workshops, learning sessions, and mentoring designed to help you advance your career with confidence.</div>
                    <div className="paragraph">We advance <span>Equity</span> by intentionally co‑creating this community with care—fostering a culture of belonging where every voice is valued and everyone feels welcome.</div>
                    <div className="paragraph">This is a place to reconnect, grow, and continue making an impact together.</div>
                </div>
                <div className="img-container">
                    <picture>
                        <source srcSet="/assets/auto-scroll/1.webp" type="image/webp" />
                        <img src="/assets/auto-scroll/1.png" alt="about-stay-connected" loading="lazy" />
                    </picture>
                </div>
            </div>

            <div className="qualities"></div>
            
            <Footer />
        </div>
    );
};
export default About;